import date from "./dateAdapter.js";
import { useBackendData, useFormState } from "./hooks.ts";

function VolunteerHoursForm({
  wp,
  action,
  registrations,
  closeModal,
  onSaved,
}) {
  const { value, setValue, error, handleSubmit, submitting } = useFormState({
    initialValue: registrations,
    action,
    handleSubmitted,
  });

  function setHoursForDay(date, event) {
    var hours = parseFloat(event.target.value);
    if (isNaN(hours) || hours < 0 || hours > 24) return;
    let newValue = { ...value };
    for (const [regId, reg] of Object.entries(registrations)) {
      var hoursId = (reg.days[date] || {}).id;
      newValue = getModifiedCell(newValue, regId, date, hours, hoursId);
    }
    setValue(newValue);
  }

  function getCell(regId, date) {
    let hours = ((value[regId] || {})[date] || {}).hours;
    if (hours === undefined) {
      hours = (registrations[regId].days[date] || {}).hours || 0;
    }
    return hours;
  }

  function updateCell(regId, date, hours, hoursId) {
    setValue(getModifiedCell(value, regId, date, hours, hoursId));
  }

  function getModifiedCell(value, regId, date, hours, hoursId) {
    if (hours.target !== undefined) {
      hours = hours.target.value;
    }
    const newValue = { ...value };
    if (newValue[regId] === undefined) {
      newValue[regId] = {};
    }
    newValue[regId][date] = { hours };
    if (hoursId === undefined) {
      hoursId = (registrations[regId].days[date] || {}).id;
    }
    if (hoursId !== undefined) {
      newValue[regId][date].id = hoursId;
    }
    return newValue;
  }

  function setException(regId, event) {
    var checked = event.target.checked ? true : false;
    setValue({
      ...value,
      [regId]: { ...value[regId], time_exception: checked },
    });
  }

  function setExceptionText(regId, event) {
    var text = event.target.value;
    setValue({
      ...value,
      [regId]: {
        ...(value[regId] || {}),
        time_exception_description: text,
      },
    });
  }

  function handleSubmitted() {
    closeModal();
    onSaved?.(value);
  }

  const startDate = date.startOfDay(date.toDate(wp.start_date_time));
  const endDate = date.endOfDay(date.toDate(wp.end_date_time));
  const days = [];
  for (
    var d = startDate;
    d.getTime() <= endDate.getTime();
    d = date.addDays(d, 1)
  ) {
    days.push({
      value: date.format(d, "YYYY-MM-DD"),
      label: date.format(d, "EEE MMM d"),
    });
  }

  return (
    <div>
      <h1>Hours Worked</h1>
      <div className="table-slider" style={{ overflowX: "scroll" }}>
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              {days.map((day) => (
                <th style={{ textAlign: "center" }}>{day.label}</th>
              ))}
            </tr>
            <tr>
              <th>Select Hrs Per Day</th>
              {days.map((day) => (
                <th style={{ width: 120 }}>
                  <input
                    type="number"
                    min="0"
                    max="24"
                    onChange={setHoursForDay.bind(null, day.value)}
                  />
                </th>
              ))}
            </tr>
          </thead>
          {Object.keys(registrations).map((regId) => {
            var reg = registrations[regId];
            return (
              <tbody key={regId}>
                <tr>
                  <td>
                    {reg.first} {reg.last}
                    <br />
                    <input
                      id={"exception-" + regId}
                      type="checkbox"
                      checked={value[regId]?.time_exception}
                      onChange={setException.bind(null, regId)}
                    />
                    <label
                      className="CheckboxLabel"
                      htmlFor={"exception-" + regId}
                    >
                      {" "}
                      Needs Review
                    </label>
                  </td>
                  {days.map((day) => (
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="text"
                        value={getCell(regId, day.value)}
                        onChange={updateCell.bind(null, regId, day.value)}
                        style={{ width: 50, textAlign: "center" }}
                      />
                    </td>
                  ))}
                </tr>
                <tr
                  style={{
                    display: value[regId]?.time_exception
                      ? "table-row"
                      : "none",
                  }}
                >
                  <td colSpan={1 + days.length} style={{ padding: 0 }}>
                    <div style={{ padding: "14.66667px 11px" }}>
                      Please describe why this needs review:
                      <textarea
                        onChange={setExceptionText.bind(null, regId)}
                        value={value[regId]?.time_exception_description}
                        style={{ width: "100%" }}
                      ></textarea>
                    </div>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </table>
      </div>
      <button
        onClick={handleSubmit}
        className="ui small button"
        disabled={submitting}
      >
        {submitting ? "Saving..." : "Save"}
      </button>
      {error ? (
        <div className="validation-error">
          <div className="container">{error}</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

function VolunteerHours({ wp, onSaved, closeModal }) {
  const data = useBackendData({ url: wp.views.hours });

  return data ? (
    <VolunteerHoursForm
      wp={wp}
      registrations={data}
      action={wp.actions.savehours}
      onSaved={onSaved}
      closeModal={closeModal}
    />
  ) : (
    <div>Loading...</div>
  );
}

export default VolunteerHours;
